import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { ScenarioFlavorEnum } from 'src/app/metrics/shared/enums';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { BasicService } from 'src/app/shared/services/basic.service';

@Component({
  selector: 'app-scenario-templates-dependencies',
  templateUrl: './scenario-templates-dependencies.component.html',
  styleUrls: ['../../../../../shared/components/confirm-dialog/confirm-dialog.component.scss'],
})
export class ScenarioTemplatesDependenciesComponent {
  dependencies: {
    url: string;
    template_name: string;
    scenario_name: string;
    boxes: { id: number; name: string };
    flavor: ScenarioFlavorEnum;
  }[] = [];

  titleKey = 'parameters/quick-replies/agent-shortcuts/disable/dependencies-title';
  descriptionKey = 'parameters/quick-replies/agent-shortcuts/disable/dependencies-found';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { deleteBox: boolean; dependencies; siteId: number },
    basicService: BasicService,
    customRouter: CustomRouter
  ) {
    if (data.deleteBox) {
      this.titleKey = 'parameters/quick-replies/agent-shortcuts/delete/dependencies-title';
      this.descriptionKey = 'parameters/quick-replies/agent-shortcuts/delete/dependencies-found';
    }
    this.dependencies = (data?.dependencies || [])
      .map(dependency => {
        const path = `/#/${customRouter.params.companyId}/fuse/parameters/message-templates/whatsapp/${data.siteId}/template/${dependency.template_name}`;
        dependency.url = basicService.fullURLForRoutePath(path);

        if (dependency.scenarioId) {
          dependency.boxes = dependency.boxes.map(box => {
            const boxId = box.id;
            const scenarioUrlWithZoom = `/#/${customRouter.params.companyId}/fuse/parameters/account/${data.siteId}/${dependency.flavor}/${dependency.scenarioId}?zoomToBoxId=${boxId}`;
            const url = basicService.fullURLForRoutePath(scenarioUrlWithZoom);
            return {
              ...box,
              url,
            };
          });
        }
        return dependency;
      })
      .reduce((result, dependency) => {
        if (!result[dependency.scenario_name]) {
          result[dependency.scenario_name] = [];
        }
        result[dependency.scenario_name] = [].concat(result[dependency.scenario_name]).concat(dependency);
        return result;
      }, {});
  }
}
